import DesignTripFolderModal from './DesignTripFolderModal';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSnack, useResetTripDesigner } from 'hooks';
import KoobLayout from '../../../components/Koob/KoobLayout';
import { useTripStore } from '@koob/trip-designer';
import { KoobLoader, useDocumentTitle } from '@koob/ui';
import { useHydrateTrip } from '../Compose/useHydrateTrip';

export const DesignTrip = () => {
  const { t } = useTranslation('tripDesigner');
  const { t: tSidebar } = useTranslation('mainSidebar');
  useDocumentTitle(tSidebar('designTrip'));
  const { notify } = useSnack();
  const { fromId } = useParams();
  const [searchParams] = useSearchParams();
  const fromDraft = searchParams.get('from') === 'draftEdit';
  const resetContext = useResetTripDesigner();
  const resetTrip = useTripStore(state => state.resetTrip);
  const hydrateTrip = useHydrateTrip();

  const navigate = useNavigate();
  const [showDesignTripModal, setShowDesignTripModal] = useState(true);
  const [loading, setLoading] = useState(!!fromId);

  useEffect(() => {
    // Only reset context and clear localStorage if we are not editing an existing trip (fromId is undefined)
    if (!fromId) {
      localStorage.removeItem('tripFiltersCache');
      localStorage.removeItem('tripDataCache');
      localStorage.removeItem('trip-designer-storage');

      resetContext();
      resetTrip();
      return;
    }

    hydrateTrip(fromId, { fromDraft })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Failed to load trip', error);
        // Surface the failure: without this the spinner just disappears and
        // the user is left with an empty modal and no way to know it failed.
        notify(t('loadTripError'), { type: 'error' });
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromId]);

  return (
    <KoobLayout>
      {!loading ? (
        <DesignTripFolderModal
          open={showDesignTripModal}
          close={() => setShowDesignTripModal(false)}
          onExit={() => {
            setShowDesignTripModal(false);
            // Cancelling: this route is nothing but the wizard, so leaving it
            // means going back where the user opened it from. (Saving instead
            // lets the host onSaved redirect to the composer.)
            navigate(-1);
          }}
        />
      ) : (
        <KoobLoader centered />
      )}
    </KoobLayout>
  );
};
